import { Grid, IconButton, InputAdornment, FormControl, InputLabel, OutlinedInput } from '@mui/material'
import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import { selectSearchTerm, sendSearchAsync, setSearchTerm } from '../../../actions/discoverSlice'
import { useDispatch, useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import { AppDispatch } from '../../../core/store'

const WhiteBoardGrid = styled(Grid)(({ theme }) => ({
	backgroundColor: '#ffffff00',
	width: '100%',
	padding: '16px',
	textAlign: 'center',
	color: theme.palette.text.secondary,
	borderRadius: '16px',
	position: 'relative'
}))
const WAIT_INTERVAL = 1000;

const SearchCard = () => {
	const dispatch = useDispatch<AppDispatch>()
	const [term, setTerm] = useState('')
	const searchedTerm = useSelector(selectSearchTerm)
	const [timer, setTimer] = useState(0);

	const onSearchTermChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let searchTerm: string = event.target.value
		console.log(searchTerm)
		setTerm(searchTerm)
		dispatch(setSearchTerm(searchTerm))
		if (timer) {
			window.clearTimeout(timer)
			setTimer(0)
		}
		setTimer(
			window.setTimeout(() => {
				dispatch(sendSearchAsync(searchTerm))
			}, WAIT_INTERVAL)
		)
	}

	const cancelAction = () => {
		setTerm('')
		dispatch(setSearchTerm(''))
	}
		
	return (
		<WhiteBoardGrid >
			<FormControl sx={{ m: 1, width: '100%' }} variant="outlined" >
				<InputLabel htmlFor="outlined-search" color='secondary' sx={{color: '#7C7CCF'}} >Recherche</InputLabel>
				<OutlinedInput
					autoFocus={true}
					id="outlined-search"
					type='text' 
					value={term}
					onChange={onSearchTermChange}
					color='secondary'
					sx={{ color: 'white!important', borderColor: 'white', borderRadius: '50px', '& fieldset': {borderRadius: '50px',borderColor: '#7C7CCF!important' , color: '#7C7CCF!important'}}} 
					endAdornment={
						searchedTerm ?
						<InputAdornment position="end">
							<IconButton
							aria-label={
								'annuler'
							}
							onClick={() => cancelAction()}
							edge="end"
							>
							<CloseIcon color='error' />
							</IconButton>
						</InputAdornment> : '' }
					label="Recherche"
				/>
			</FormControl>

			{/* <TextField 
				key='search' 
				id='search_field' 
				label='Rechercher' 
				variant='outlined'
				value={term}
				sx={{width: '85%', margin: '5%', color: 'white', border: 'none', backgroundColor: '#ffffff', borderRadius: '50px', '& .MuiOutlinedInput-root': {'& fieldset': {borderRadius: '50px', color: 'white'}}}} 
				onChange={onSearchTermChange}
				endAdornment={
					searchedTerm
					?
						//  <InputAdornment position="end">
						// 	<IconButton color='red' onClick={cancelAction}>
						// 		<CloseIcon />
						// 	</IconButton>
						// </InputAdornment>
					: 
						''
				}
				/> */}

		</WhiteBoardGrid>
		)
}

export default SearchCard